import { defineStore } from 'pinia'
import type { ExperienceStatisticsResponse, StatisticItem } from '~/api/v2/experiences/ExperienceRepository'

export const useExperienceStatisticsStore = defineStore('experienceStatistics', {
  state: () => ({
    statistics: null as ExperienceStatisticsResponse | null,
    loading: false,
    error: null as string | null,
  }),

  getters: {
    companySizeStatistics: (state): StatisticItem[] => state.statistics?.company_sizes || [],
    dealSizeStatistics: (state): StatisticItem[] => state.statistics?.deal_sizes || [],
    marketSegmentStatistics: (state): StatisticItem[] => state.statistics?.market_segments || [],
  },

  actions: {
    async fetchStatistics(userId?: string) {
      try {
        this.loading = true
        this.error = null

        const { $api } = useNuxtApp()
        this.statistics = await $api().v2.experiences.getStatistics(userId)
      } catch (error) {
        console.error('Error fetching experience statistics:', error)
        this.error = error instanceof Error ? error.message : 'Failed to fetch experience statistics'
        throw error
      } finally {
        this.loading = false
      }
    },

    clearStatistics() {
      this.statistics = null
      this.error = null
    }
  }
})